import { AppContext } from 'context';
import { useContext } from 'react';

export const useHandleStepBack = () => {
  const context = useContext(AppContext);
  const { steps } = context.state;

  const handleStepBack = () => {
    if (steps.currentStep) {
      context.dispatch({
        type: 'update_step',
        payload: { currentStep: steps.currentStep - 1 },
      });
    }
  };

  return handleStepBack;
};
